import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Table, Alert, Spinner, Card } from "react-bootstrap";

const DiscountsSavingsReport = () => {
  const [discountsData, setDiscountsData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch discounts and savings data
  const fetchDiscountsData = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/discounts-savings/");
      setDiscountsData(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب تقرير الخصومات والتوفير.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDiscountsData();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير الخصومات والتوفير</h1>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Discounts and Savings Table */
        <Card style={{ padding: "20px", border: "1px solid darkgreen", borderRadius: "5px" }}>
          <h4 style={{ color: "darkgreen" }}>تحليل الخصومات والتوفير</h4>
          <Table hover responsive>
            <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
              <tr>
                <th>اسم الموظف</th>
                <th>إجمالي الخصم</th>
                <th>عدد المشتريات</th>
              </tr>
            </thead>
            <tbody>
              {discountsData?.map((employee, index) => (
                <tr key={index}>
                  <td>{employee.employee_name}</td>
                  <td>{employee.total_discount ? employee.total_discount.toFixed(2) : "لا يوجد"}</td>
                  <td>{employee.number_of_purchases}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
    </Container>
  );
};

export default DiscountsSavingsReport;
